export function UserPlusFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M10.5 12c2 0 5-2.462 5-5.5S13.262 1 10.5 1c-2.761 0-5 2.462-5 5.5s3 5.5 5 5.5z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.082 13a5.99 5.99 0 00-5.846 4.69l-.302 1.359A1.603 1.603 0 004.499 21h8.029a6 6 0 10-.062-7.93 6.484 6.484 0 00-.952-.07H9.082zM17 13a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 110-2h2v-2a1 1 0 011-1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
